var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("pickupTour", {
        ref: "pickupTour",
        attrs: { id: "pickupTour" },
        on: { tourStoped: _vm.stopTour },
      }),
      _c("div", { attrs: { id: "pickupTourContainer" } }),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.showStats,
            scroll: "keep",
            "has-modal-card": "",
            "full-screen": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.showStats = $event
            },
          },
        },
        [
          _c("stats", {
            attrs: { mails: _vm.selectedMails, "range-dates": _vm.rangeDates },
            on: { close: _vm.closeStatsScreen },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.showMailTemplates,
            scroll: "keep",
            "has-modal-card": "",
            "full-screen": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.showMailTemplates = $event
            },
          },
        },
        [
          _c("mailTemplates", {
            attrs: { "selected-group": _vm.selectedGroup },
            on: {
              nextTourStep: _vm.nextTourStep,
              close: _vm.closeMailTemplates,
            },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.showSignature,
            scroll: "keep",
            "has-modal-card": "",
            "full-screen": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.showSignature = $event
            },
          },
        },
        [
          _c("signature", {
            attrs: { "selected-group": _vm.selectedGroup },
            on: { close: _vm.closeSignatureScreen },
          }),
        ],
        1
      ),
      !_vm.showDeclaration &&
      !_vm.showStats &&
      !_vm.showSignature &&
      !_vm.showMailTemplates
        ? _c("div", [
            _c(
              "section",
              [
                _c("div", { staticClass: "pickup-actions-container" }, [
                  _c(
                    "span",
                    [
                      _c(
                        "b-tooltip",
                        {
                          attrs: {
                            label: _vm.$t(
                              "pages.pickup_management.clear_filters"
                            ),
                            position: "is-top",
                          },
                        },
                        [
                          _c("b-button", {
                            attrs: {
                              "icon-left": "filter",
                              type: "is-danger",
                              rounded: "",
                            },
                            on: { click: _vm.clearFilters },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    [
                      _c(
                        "b-tooltip",
                        {
                          attrs: {
                            id: "pickupTourBtn",
                            label: _vm.$t(
                              "pages.pickup_management.page_tutorial"
                            ),
                            position: "is-top",
                          },
                        },
                        [
                          _c("b-button", {
                            attrs: {
                              "icon-left": "question",
                              type: "is-info",
                              rounded: "",
                            },
                            on: { click: _vm.startTour },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "columns" }, [
                  _c(
                    "div",
                    { staticClass: "column is-one-fifth" },
                    [
                      _c(
                        "b-field",
                        {
                          attrs: {
                            label: _vm.$t(
                              "pages.pickup_management.pickup_management.range_dates_label"
                            ),
                          },
                        },
                        [
                          _c("b-datepicker", {
                            attrs: {
                              placeholder: "Click to select...",
                              range: "",
                            },
                            model: {
                              value: _vm.rangeDates,
                              callback: function ($$v) {
                                _vm.rangeDates = $$v
                              },
                              expression: "rangeDates",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.selectedGroup
                    ? _c(
                        "div",
                        { staticClass: "custom-container buttons column" },
                        [
                          _vm.selectedGroup.collectGroup === "ALL"
                            ? _c(
                                "b-button",
                                {
                                  class: _vm.isSiburScreen ? "" : "is-orange",
                                  attrs: {
                                    "icon-left": _vm.isSiburScreen
                                      ? "right-from-bracket"
                                      : "users",
                                    disabled: _vm.loading,
                                  },
                                  on: { click: _vm.toggleSiburScreen },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.isSiburScreen
                                          ? "Leave Sibur Screen"
                                          : "Sibur Screen"
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "b-button",
                            {
                              staticClass: "button",
                              class:
                                _vm.filteredEndusers === _vm.computedEndusers
                                  ? "is-purple"
                                  : "is-danger",
                              attrs: {
                                "icon-left": "eye-slash",
                                disabled: _vm.loading,
                              },
                              on: { click: _vm.showNotSeenDeclarations },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "pages.pickup_management.pickup_management.show_not_seen_declarations"
                                    )
                                  ) +
                                  " "
                              ),
                              _c("span", { staticClass: "count" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.notSeenDeclaration.length) +
                                    " "
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "b-button",
                            {
                              staticClass: "button is-primary",
                              attrs: {
                                "icon-left": "map",
                                disabled: _vm.loading,
                              },
                              on: {
                                click: () => {
                                  _vm.showMap = true
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "pages.pickup_management.pickup_management.open_map"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "b-button",
                            {
                              staticClass: "button is-link",
                              attrs: {
                                id: "pickup-step-4",
                                "icon-left": "envelope-square",
                                disabled: _vm.loading,
                              },
                              on: {
                                click: () => {
                                  _vm.showMailTemplates = true
                                  _vm.nextTourStep("createMailTemplates")
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "pages.pickup_management.pickup_management.manage_mail_templates"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "b-button",
                            {
                              staticClass: "button is-info",
                              attrs: {
                                id: "pickup-step-17",
                                "icon-left": "signature",
                                disabled: _vm.loading,
                              },
                              on: {
                                click: () => {
                                  _vm.showSignature = true
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "pages.pickup_management.pickup_management.edit_signature"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "b-button",
                            {
                              staticClass: "button",
                              class: _vm.rowSelection
                                ? "is-purple"
                                : "is-danger",
                              attrs: {
                                id: "pickup-step-17",
                                "icon-left": "hand-pointer",
                                disabled: _vm.loading,
                              },
                              on: { click: _vm.switchRowSelection },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "pages.pickup_management.pickup_management.row_selection"
                                    ) + " : "
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm.rowSelection
                                      ? _vm.$t(
                                          "pages.pickup_management.pickup_management.row"
                                        )
                                      : _vm.$t(
                                          "pages.pickup_management.pickup_management.cell"
                                        )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "b-button",
                            {
                              staticClass: "button",
                              attrs: {
                                loading: _vm.loading,
                                disabled: _vm.loading,
                              },
                              on: { click: _vm.setRowsUnseen },
                            },
                            [_vm._v(" Set unseen ")]
                          ),
                          _c(
                            "b-button",
                            {
                              staticClass: "button is-warning",
                              attrs: {
                                loading: _vm.loading,
                                "icon-left": "sync",
                                disabled: _vm.loading,
                              },
                              on: { click: () => _vm.refresh() },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "pages.pickup_management.pickup_management.refresh"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "caption" }, [
                  _c("span", { staticClass: "caption-title" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "pages.pickup_management.pickup_management.caption"
                          )
                        ) +
                        " "
                    ),
                  ]),
                  _c("br"),
                  _c("i", {
                    staticClass: "fas fa-exclamation-circle has-text-warning",
                  }),
                  _vm._v(
                    " : " +
                      _vm._s(
                        _vm.$t(
                          "pages.pickup_management.pickup_management.declaration_with_comments"
                        )
                      ) +
                      " "
                  ),
                  _c("br"),
                  _c("i", { staticClass: "fas fa-info has-text-info" }),
                  _vm._v(
                    " : " +
                      _vm._s(
                        _vm.$t(
                          "pages.pickup_management.pickup_management.enduser_with_comments"
                        )
                      ) +
                      " "
                  ),
                ]),
                _c("ag-grid-vue", {
                  staticClass: "ag-theme-balham",
                  staticStyle: {
                    width: "100%",
                    height: "700px",
                    "z-index": "1",
                  },
                  attrs: {
                    "row-data": _vm.filteredEndusers,
                    "grid-options": _vm.gridOptions,
                    pagination: true,
                    "pagination-auto-page-size": true,
                    "multi-sort-key": "ctrl",
                    modules: _vm.modules,
                    "row-selection": _vm.rowSelection,
                    "enable-range-selection": true,
                  },
                  on: { "grid-ready": _vm.gridReady },
                }),
              ],
              1
            ),
          ])
        : _vm.showDeclaration
        ? _c("div", { staticClass: "section" }, [
            _c("span", { staticClass: "buttons" }, [
              _c(
                "button",
                {
                  staticClass: "button is-warning is-outlined is-small",
                  on: {
                    click: () => {
                      _vm.showDeclaration = false
                      _vm.loadData()
                    },
                  },
                },
                [
                  _c("b-icon", { attrs: { icon: "chevron-left" } }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("global.back")))]),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "card-content" }, [
              _c("div", { staticClass: "has-text-centered" }, [
                _c("h2", { staticClass: "title" }, [
                  _vm._v(
                    " " + _vm._s(_vm.selectedMailDeclaration.enduserName) + " "
                  ),
                ]),
                _c("i", { staticClass: "title" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm
                          .$dayjs(_vm.selectedMailDeclaration.date)
                          .local()
                          .format("DD-MM-YYYY HH:mm")
                      ) +
                      " "
                  ),
                ]),
                _c("br"),
                _c("i", [_vm._v(" (DD-MM-YYYY HH:mm) ")]),
              ]),
              _c("div", { staticClass: "mb" }, [
                _c("h2", { staticClass: "title" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "pages.pickup_management.pickup_management.declaration.identity"
                        )
                      ) +
                      " "
                  ),
                ]),
                _c("div", { staticClass: "card" }, [
                  _vm.selectedMailDeclaration.identity
                    ? _c("span", { staticClass: "commentsSection" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.selectedMailDeclaration.identity) +
                            " "
                        ),
                      ])
                    : _c("span", { staticClass: "commentsSection" }, [
                        _c("i", [_vm._v(_vm._s(_vm.$t("global.no_data")))]),
                      ]),
                ]),
              ]),
              _c("div", { staticClass: "mb" }, [
                _c("h2", { staticClass: "title" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "pages.pickup_management.pickup_management.declaration.comments"
                        )
                      ) +
                      " "
                  ),
                ]),
                _c("div", { staticClass: "card" }, [
                  _vm.selectedMailDeclaration.comments
                    ? _c("span", { staticClass: "commentsSection" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.selectedMailDeclaration.comments) +
                            " "
                        ),
                      ])
                    : _c("span", { staticClass: "commentsSection" }, [
                        _c("i", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "pages.pickup_management.pickup_management.declaration.no_comments"
                              )
                            )
                          ),
                        ]),
                      ]),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "columns is-multiline" },
              _vm._l(_vm.declarationQuantities, function (dc) {
                return _c(
                  "div",
                  { key: dc.material, staticClass: "column is-one-third" },
                  [
                    _c("div", { staticClass: "card has-text-centered" }, [
                      _c("div", { staticClass: "card-header" }, [
                        _c("span", { staticClass: "card-header-title" }, [
                          _vm._v(" " + _vm._s(dc.material) + " "),
                        ]),
                      ]),
                      _c("div", { staticClass: "card-content" }, [
                        _c(
                          "h2",
                          {
                            staticClass: "title",
                            class: dc.quantity > 0 ? "has-text-primary" : null,
                          },
                          [_vm._v(" " + _vm._s(dc.quantity) + " ")]
                        ),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.showMap,
            scroll: "clip",
            "has-modal-card": "",
            "full-screen": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.showMap = $event
            },
          },
        },
        [
          _c("Map", {
            attrs: {
              endusers: _vm.computedEndusers,
              "enduser-code": _vm.selectedEnduserCode,
              "selected-group": _vm.selectedGroup,
              collects: _vm.collects,
            },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.settingMailTemplate,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.settingMailTemplate = $event
            },
          },
        },
        [
          [
            _c("div", { staticClass: "modal-card" }, [
              _c("header", { staticClass: "modal-card-head" }, [
                _c("p", { staticClass: "modal-card-title" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "pages.pickup_management.pickup_management.set_mail_template"
                        )
                      ) +
                      " "
                  ),
                ]),
              ]),
              _c(
                "section",
                {
                  staticClass: "modal-card-body",
                  attrs: { id: "pickup-step-14" },
                },
                [
                  _vm.selectedGroup && _vm.mailTemplates
                    ? _c(
                        "b-select",
                        {
                          attrs: {
                            placeholder: _vm.$t(
                              "pages.pickup_management.pickup_management.select_template"
                            ),
                          },
                          model: {
                            value: _vm.selectedMailTemplate,
                            callback: function ($$v) {
                              _vm.selectedMailTemplate = $$v
                            },
                            expression: "selectedMailTemplate",
                          },
                        },
                        [
                          _vm._l(
                            _vm.mailTemplates.filter(
                              (m) =>
                                m.collectGroup ===
                                _vm.selectedGroup.collectGroup
                            ),
                            function (template) {
                              return _c(
                                "option",
                                {
                                  key: template.id,
                                  domProps: { value: template },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(template.templateName) + " "
                                  ),
                                ]
                              )
                            }
                          ),
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "pages.pickup_management.pickup_management.none"
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("footer", { staticClass: "modal-card-foot" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-fullwidth",
                    on: {
                      click: () => {
                        _vm.settingMailTemplate = false
                        _vm.nextTourStep("closeSettingMailTemplate")
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "button is-info is-fullwidth",
                    attrs: {
                      id: "pickup-step-15",
                      disabled: _vm.selectedMailTemplate === null,
                    },
                    on: { click: _vm.setMailTemplate },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
                ),
              ]),
            ]),
          ],
        ],
        2
      ),
      _vm.selectedEnduser
        ? _c(
            "b-modal",
            {
              attrs: {
                active: _vm.settingEnduserComments,
                scroll: "keep",
                "has-modal-card": "",
              },
              on: {
                "update:active": function ($event) {
                  _vm.settingEnduserComments = $event
                },
              },
            },
            [
              [
                _c("div", { staticClass: "modal-card" }, [
                  _c("header", { staticClass: "modal-card-head" }, [
                    _c("p", { staticClass: "modal-card-title" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "pages.pickup_management.pickup_management.set_enduser_comments"
                            )
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                  _c(
                    "section",
                    {
                      staticClass: "modal-card-body",
                      attrs: { id: "pickup-step-14" },
                    },
                    [
                      _c("b-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.selectedEnduser.infos.comments,
                          callback: function ($$v) {
                            _vm.$set(_vm.selectedEnduser.infos, "comments", $$v)
                          },
                          expression: "selectedEnduser.infos.comments",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("footer", { staticClass: "modal-card-foot" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button is-fullwidth",
                        on: {
                          click: () => {
                            _vm.settingEnduserComments = false
                            _vm.selectedEnduser.infos.comments = _vm.tmp
                            _vm.selectedEnduser = null
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "button is-info is-fullwidth",
                        attrs: { id: "pickup-step-15" },
                        on: { click: _vm.setEnduserComments },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
                    ),
                  ]),
                ]),
              ],
            ],
            2
          )
        : _vm._e(),
      _vm.isDetailedModalOpen
        ? _c(
            "b-modal",
            {
              attrs: {
                active: _vm.isDetailedModalOpen,
                scroll: "keep",
                "has-modal-card": "",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isDetailedModalOpen = $event
                },
              },
            },
            [
              [
                _c("div", { staticClass: "modal-card" }, [
                  _c("header", { staticClass: "modal-card-head" }, [
                    _c("p", { staticClass: "modal-card-title" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.selectedEnduser.enduserCode) +
                          " - " +
                          _vm._s(_vm.selectedEnduser.enduserName) +
                          " "
                      ),
                    ]),
                  ]),
                  _c("section", { staticClass: "modal-card-body" }, [
                    _c("p", [
                      _c("strong", [_vm._v("Address: ")]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.selectedEnduser.address) +
                          " - " +
                          _vm._s(_vm.selectedEnduser.city)
                      ),
                    ]),
                    _c("p", [
                      _c("strong", [_vm._v("Postal code:")]),
                      _vm._v(" " + _vm._s(_vm.selectedEnduser.postalCode)),
                    ]),
                    _c("p", [
                      _c("strong", [_vm._v("Country:")]),
                      _vm._v(" " + _vm._s(_vm.selectedEnduser.country)),
                    ]),
                    _c("p", [
                      _c("strong", [_vm._v("Tel:")]),
                      _vm._v(" " + _vm._s(_vm.selectedEnduser.enduserTel)),
                    ]),
                  ]),
                ]),
              ],
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }